// src/utils/adminRoles.js

export const ADMIN_ROLES = ["owner", "dev", "adm", "cs"];
export const ADMIN_PRIVILEGED_ROLES = ["owner", "dev", "adm"];
export const OWNER_ONLY_ROLE = ["owner"];

export function isAdmin(role) {
  return ADMIN_ROLES.includes(role);
}

export function isAdminPrivileged(role) {
  return ADMIN_PRIVILEGED_ROLES.includes(role);
}

export function isOwner(role) {
  return OWNER_ONLY_ROLE.includes(role);
}

export function hasRole(role, allowedRoles = []) {
  return allowedRoles.includes(role);
}
